import React, { useState, useMemo } from "react";
import { Select } from "antd";
import { useGetSubjectsQuery } from "../../../../hooks/api/Admin/Courses/useGetSubjectsQuery";

// Define types for subjects and categories
interface Subject {
  subject: string;
}

interface Categories {
  [categoryName: string]: Subject[];
}

type Props = {};

const { Option, OptGroup } = Select;

const UpdateExpertiseSelect: React.FC<Props> = (props: Props) => {
  const [payload, setPayload] = useState<{ ids: string[] }>({
    ids: ["601c5f4d03c3f10a4c8b4601", "601c5f4d03c3f10a4c8b4602"],
  });

  const { data: subjectsResponse, isLoading } = useGetSubjectsQuery({
    page: 1,
    limit: 100,
  });

  const categories: Categories = subjectsResponse?.data?.categories || {};

  const categoryOptions = useMemo(() => {
    return Object.entries(categories).map(([categoryName, subjectArray]) => (
      <OptGroup key={categoryName} label={categoryName}>
        {subjectArray.map((subject) => (
          <Option key={subject.subject} value={subject.subject}>
            {subject.subject}
          </Option>
        ))}
      </OptGroup>
    ));
  }, [categories]);

  return (
    <div>
      <Select
        mode="multiple"
        maxCount={8} // Changed from 4 to 8 based on placeholder description
        placeholder="Select up to 8 subjects"
        className="w-full mt-2 capitalize"
        size="large"
        value={payload.ids}
        onChange={(value: string[]) => setPayload({ ids: value })}
        loading={isLoading}
      >
        {categoryOptions}
      </Select>
    </div>
  );
};

export default UpdateExpertiseSelect;
